.part + .part {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--mantine-color-gneis-1);
}

.relationsHeader {
    display: flex;
    align-items: flex-start;
    gap: var(--mantine-spacing-xs);
    margin-bottom: var(--mantine-spacing-sm);
}

.relationsHeaderIcon {
    flex: 0 0 auto;
    width: 1rem;
    height: 1.25rem;
    color: var(--mantine-color-dimmed);
}

.relationsHeaderTitle {
    font-weight: 600;
    font-size: var(--mantine-font-size-md);
}

.relationGroup {
    margin-bottom: var(--mantine-spacing-md);
}

.relationGroupHeading {
    font-size: var(--mantine-font-size-lg);
    font-weight: 600;
    border-bottom: 1px solid var(--mantine-color-gneis-1);
    padding-bottom: 0.25rem;
    margin: var(--mantine-spacing-sm) 0 var(--mantine-spacing-xs);
}

.topicBlock {
    margin-bottom: var(--mantine-spacing-sm);
}

.topicHeading {
    font-size: var(--mantine-font-size-md);
    margin: var(--mantine-spacing-xs) 0 0;
}

.topicLinks {
    list-style: none;
    padding-left: var(--mantine-spacing-xs);
    margin: 0;
}

.topicLinks li,
.topicListPlain li {
    padding: 0.125rem 0;
    font-size: var(--mantine-font-size-sm);
}

.topicListPlain {
    list-style: none;
    padding: 0;
    margin: 0;
}
